
export const ADD_HISTORY_STEP = "ADD_HISTORY_STEP";
export const ADD_PATH_STEP = "ADD_PATH_STEP";
export const ADD_FILE = "ADD_FILE";